import { randomString } from '@/views/utils'
import { HasId } from '@/repositories/fuzoku-meisai/data'

export interface UiItem<T extends HasId> {
  isValid: boolean;
  item: T
}

export class UiItemsLogic {
  static upUiItem<T extends HasId, V extends UiItem<T>> (items: V[], target: V) {
    const index = items.findIndex(i => i.item.id === target.item.id)
    const deletedItems = items.splice(index, 1)
    items.splice(index - 1, 0, deletedItems[0])
  }

  static downUiItem<T extends HasId, V extends UiItem<T>> (items: V[], target: V) {
    const index = items.findIndex(i => i.item.id === target.item.id)
    const deletedItems = items.splice(index, 1)
    items.splice(index + 1, 0, deletedItems[0])
  }

  static removeUiItem<T extends HasId, V extends UiItem<T>> (items: V[], target: V) {
    const index = items.findIndex(i => i.item.id === target.item.id)
    items.splice(index, 1)
  }

  static updateUiItem<T extends HasId, V extends UiItem<T>> (items: V[], target: V) {
    const index = items.findIndex(i => i.item.id === target.item.id)
    items[index] = target
  }

  static makeId<T extends HasId, V extends UiItem<T>> (items: V[]): string {
    let newId: string
    do {
      newId = randomString(12)
    } while (items.filter(i => i.item.id === newId).length)
    return newId
  }
}
